import { Box, Flex } from '@televet/kibble-ui/build/chakra';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { useConversationsContext } from 'pages/Conversations/context/ConversationsContext';
import React from 'react';
import { TeletriageConversationCenterFilters } from './TeletriageConversationCenterFilters';

export const TeletriageConversationCenterToolbar = (): JSX.Element => {
  const { teletriageConversationCenter } = useConversationsContext();

  const {
    // Filters
    filters,
    setFilters,
    clearFilters,
    toggleShowArchived,
    toggleSearch,
    isSearchingOpen,
  } = teletriageConversationCenter;

  return (
    <Box className="TeletriageConversationCenter__Toolbar" bg="background.default">
      <Flex
        className="TeletriageConversationCenter__Toolbar--Buttons"
        borderBottom="1px"
        borderBottomColor="border.default"
        width="100%"
        px={4}
        py={3}
        height="57px"
        alignItems="center"
        gap={2}
      >
        <Button
          variant="ghostNeutral"
          iconName="magnifyingGlass"
          isActive={isSearchingOpen}
          onClick={(): void => toggleSearch((curr) => !curr)}
        />
        <TeletriageConversationCenterFilters
          filters={filters}
          setFilters={setFilters}
          clearFilters={clearFilters}
          toggleShowArchived={toggleShowArchived}
        />
      </Flex>
    </Box>
  );
};
